import React from "react";
import { TextField, InputAdornment, IconButton, TextFieldProps } from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import useText from "constants/text";

export default function SearchBox(props: TextFieldProps) {
  const { text } = useText();
  return (
    <TextField
      id="search-box"
      {...props}
      label={text.all.search}
      placeholder={props.placeholder}
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton edge="end">
              <Search />
            </IconButton>
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
}
